import React from 'react';
import * as S from './styled';
export const TableCell = ({ width = 1, $minWidth, height, $minHeight, $compact, $alignment = 'left', $alignItems = 'center', $justifyContent = 'start', children, }) => {
    return (React.createElement(S.Container, { role: "cell", width: width, "$minWidth": $minWidth, height: height, "$minHeight": $minHeight, "$compact": $compact, "$alignment": $alignment, "$alignItems": $alignItems, "$justifyContent": $justifyContent, "data-testid": "TableCell" }, children));
};
